import Step, { IStep } from "./Step";

const MultiStepWizard: React.FC<MultiStepWizardProps> = ({
  steps,
  isActive,
}) => {

  return (
    <>
      {steps.map((step) => (
        <Step
          key={step.index}
          index={step.index}
          isActive={isActive(step.index)}
          stepTitle={step.stepTitle}
          dontHideInactive={step.dontHideInactive}
        >
          {step.children}
        </Step>
      ))}
    </>
  )
}

export default MultiStepWizard;

interface MultiStepWizardProps {
  steps: IStep [];
  isActive: (index: number) => boolean;
}